import { Component, HostListener, Input, SimpleChanges } from '@angular/core';
import { AppConstants } from 'src/app/app.constants';
import { HeaderService } from 'src/_lib/service/header.service';
import { CommunicationService } from 'src/_lib/service/communication.service';
import { HeadersDataInterface } from 'src/_lib/interfaces/header.interface';
import { environment } from 'src/environments/environment.prod';
import { Router, RouterLink } from '@angular/router';
import { OffcanvasService } from 'src/_lib/service/offcanvasslide.service';
import { HeaderSearchComponent } from '../header-search/header-search.component';
import { CommonModule, NgClass } from '@angular/common';
import { headerSetting } from 'src/_lib/interfaces/homepagesettings.interface';
import { SearchByVehicleComponent } from 'src/app/templates/search-by-vehicle/search-by-vehicle.component';
import { MatDialog } from '@angular/material/dialog';
import { CommanpageService } from 'src/_lib/service/commanpages.service';
import { ShopByVehicleComponent } from 'src/app/templates/shop-by-vehicle-btn/shop-by-vehicle.component';
import { SanitizeHtmlPipe } from 'src/_lib/pipes/sanitizeHtml';
import { BrowserService } from 'src/_lib/service/browser.service';
import { DynamicThemeClassService } from 'src/_lib/service/dynamic-theme-class.service';

@Component({
  selector: 'app-header-mobile-menu',
  templateUrl: './header-mobile-menu.component.html',
  styleUrls: ['./header-mobile-menu.component.scss'],
  standalone: true,
  imports: [RouterLink, HeaderSearchComponent, CommonModule, NgClass, ShopByVehicleComponent,SanitizeHtmlPipe],
  host: { 'ngSkipHydration': 'true' },
})
export class HeaderMobileMenuComponent {
  firstObj: number = this.appConstants.firstObj;
  cartItems: number = null;
  wishItems: number;
  chTheme1 = environment.chTheme1;
  chTheme3 = environment.chTheme3;
  chTheme2 = environment.chTheme2;
  chTheme4 = environment.chTheme4;
  chTheme5 = environment.chTheme5;
  chTheme7 = environment.chTheme7;
  chTheme8 = environment.chTheme8;
  chTheme10 = environment.chTheme10;
  chTheme13 = environment.chTheme13;
  chTheme14 = environment.chTheme14;
  cdnImagePath: string = environment.cdnImagePath;
  commonImagePath: string = environment.commonImagePath;
  headerdata: HeadersDataInterface = {
    websiteHeader: [],
    firstRow: [],
    secondRow: [],
    thirdRow: [],
  };
  headerdataLogo: any;
  isSticky = false;
  showSearch = false;
  showSecondRowHeader: boolean = false;
  showLogo: boolean = false;
  contact: string = environment.contact_no;
  formatted_contact: string = this.contact.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
  @Input() custom_ticker: any;
  @Input() headerSettings: headerSetting<string> = null;
  isSearchByVehicleDisabled: boolean = false;

  constructor(
    private headerHttp: HeaderService,
    private appConstants: AppConstants,
    private comm: CommunicationService,
    private router: Router,
    private offcanvasService: OffcanvasService,
    public dialog: MatDialog,
    private commanService: CommanpageService,
    private browser: BrowserService,
    private dynamicThemeClassService: DynamicThemeClassService
  ) { }
  themeClass(divName: string): string {
    return this.dynamicThemeClassService.generateClassName(divName);
  }

  ngOnInit(): void {
    this.comm.showVehicleButton.subscribe(() => {
      const vehicleBtnData =
        this.commanService.isSearchByVehicleDisabled();
      this.isSearchByVehicleDisabled = vehicleBtnData?.header_link;
    });
    this.getheaderList();
    this.getOrderItems();
    this.getWishItems();
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.isSticky = this.browser.window?.scrollY > 150;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['headerSettings']?.currentValue) {
      this.headerSettings = changes['headerSettings']?.currentValue;
      this.showSecondRowHeader =
        this.headerSettings.second_row_header === 'true';
      this.showLogo = this.headerSettings.logo === 'true';
    }
  }

  getOrderItems(): void {
    const previousItemCount = this.cartItems;
    this.cartItems = +this.browser.localStorage?.getItem('ItemCount') || 0;

    // Check if an item was recently added by looking for the 'ItemRecentlyAdded' flag
    if (
      this.browser.localStorage?.getItem('ItemRecentlyAdded') &&
      this.cartItems > previousItemCount
    ) {
      this.browser.localStorage?.removeItem('ItemRecentlyAdded');
    }

    // Update subscription to check for item count changes
    this.comm.itemCount.subscribe(() => {
      const newItemCount = +this.browser.localStorage?.getItem('ItemCount') || 0;
      if (
        this.browser.localStorage?.getItem('ItemRecentlyAdded') &&
        newItemCount > this.cartItems
      ) {
        this.browser.localStorage?.removeItem('ItemRecentlyAdded');
      }
      this.cartItems = newItemCount;
    });
  }

  getWishItems(): void {
    this.wishItems = +this.browser.localStorage?.getItem('wishlistItem') || 0;
    this.comm.wishlistCount.subscribe(() => {
      this.wishItems = +this.browser.localStorage?.getItem('wishlistItem') || 0;
    });
  }

  showSearchBar(): void {
    this.showSearch = true;
  }

  getheaderList(): void {
    this.headerHttp.headerList().subscribe((data) => {
      this.headerdataLogo = data[this.firstObj].data;
      this.headerdata = data[this.firstObj]?.data?.secondRow;
    });
  }
  getLoggedInUserName(): string | null {
    return this.browser.localStorage?.getItem('Username');
  }

  onAccountButton(): void {
    const user = this.getLoggedInUserName();
    if (user) {
      this.openAccountOffcanvas();
    } else {
      this.goToLogin();
    }
  }

  goToLogin() {
    const currentUrl = this.router.url;
    this.browser.localStorage?.setItem('redirectAfterLogin', currentUrl);
    this.router.navigate(['/customer-login']);
  }

  openCartOffcanvas() {
  this.browser.window?.dispatchEvent(new Event('open-shopping-cart'));
  requestAnimationFrame(() => {
    this.offcanvasService.open('shoppingCartOffcanvas');
  });
}

  openAccountOffcanvas() {
    this.browser.window?.dispatchEvent(new Event('open-account-popup'));
    requestAnimationFrame(() => {
      this.offcanvasService.open('myAccountOffcanvas');
    });
  }

  scrollTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  
  openVechicleSearchPopup(): void {
    this.dialog.open(SearchByVehicleComponent, {
      width: '600px',
      panelClass: 'search-by-vehicle-dialog',
    });
  }
}
